import React from "react";

import { withFormik, Form } from "formik";
import * as Yup from "yup";

import { useState } from "react";
import { Row } from "react-bootstrap";
import Customer from "../../../../../types/Customer";

import ActionFormButton from "../../../../common/ActionFormButton";
import CustomInput from "../../../../common/CustomInput";
import {
  getRowItemObject,
  renderRowWithSingleItem,
  Section,
  renderSectionTitle,
  RowItem,
  renderRowWithTwoItems,
  renderRowWInputNCheckbox,
  Wrapper,
  renderRowWithSelect,
} from "../../../../common/FormUtils";
import CustomerOrders from "./components/CustomerOrders";
import getCustomerQuestions from "../../../../../database/customers/getCustomerQuestions";
import Table from "../../../../common/table";
import questionTabConfig from "./config/questionTabConfig";
import getCustomerActionTracking from "../../../../../database/customers/getCustomerActionTracking";
import { Habit } from "../../../../../types/Habit";

const renderName = (props: any): Object => {
  const nameFieldData = getRowItemObject(
    "Nombre",
    "Enter the Name of the Customer",
    "text",
    "fullName"
  );
  const isActive = getRowItemObject(
    "Is Active?",
    "Enter if you want to activate this customer",
    "checkbox",
    "isActive"
  );

  return renderRowWInputNCheckbox(nameFieldData, isActive, props);
};

const renderPersonalInfoSection = (props: any) => {
  const emailFieldData = getRowItemObject(
    "Email",
    "Enter the customer's email",
    "text",
    "email"
  );
  const phoneFieldData = getRowItemObject(
    "Phone Number",
    "Enter the customer's phone number",
    "text",
    "phoneNumber"
  );
  const passwordFieldData = getRowItemObject(
    "Password",
    "Enter the customer's password",
    "text",
    "password"
  );
  const confirmPasswordFieldData = getRowItemObject(
    "Confirm Password",
    "Confirm the customer's password",
    "text",
    "confirmPassword"
  );

  return (
    <Section>
      {renderSectionTitle("Information")}
      {renderName(props)}
      {props.mode === "create" && renderRowWithTwoItems(emailFieldData, phoneFieldData, props)}
      {props.mode === "create" && renderRowWithTwoItems(passwordFieldData, confirmPasswordFieldData, props)}
    </Section>
  );
};
/*
const renderContactSection = (props: any): Object => {
  const phoneNumberFieldData = getRowItemObject(
    "Teléfono",
    "Ingresa el teléfono del cliente",
    "text",
    "phoneNumber"
  );
  const emailFieldData = getRowItemObject(
    "Correo Electrónico",
    "Ingresa el correo electrónico del cliente",
    "text",
    "email"
  );

  return renderRowWithTwoItems(phoneNumberFieldData, emailFieldData, props);
};
*/
const renderContactSection = (item) => {
  return (
    <Section>
      {renderSectionTitle("Contacto")}
      <Row>
        <RowItem>
          <CustomInput
            disabled={true}
            value={item.email}
            label={"Correo electrónico"}
          />
        </RowItem>
      </Row>
    </Section>
  );
};

const renderObservationSection = (props: any) => {
  const observationFieldData = getRowItemObject(
    "",
    "If necessary, enter with some extra information about Customer",
    "textarea",
    "obs"
  );

  return (
    <Section>
      {renderSectionTitle("Observations")}
      {renderRowWithSingleItem(observationFieldData, props)}
    </Section>
  );
};

type Props = {
  item: Customer;
  mode: string;
  storeId: string;
  onChageFormToEditMode;
  handleSubmit;
  isSubmitting;
  onCreateItem;
  onEditItem;
  actions: Habit[];
  customers: Customer[];
  onSetFreeAccess: (
    userId: string,
    durationDays: number | null,
    enabled?: boolean
  ) => Promise<{ active: boolean; expiresAt: string | null }>;
};

const CustomerForm = (props: Props): any => {
  const { item, actions, mode } = props;
  const { questions } = getCustomerQuestions({ userId: item.id });
  const actionTracking = getCustomerActionTracking({ userId: item.id });

  const [isSaleDetailDialogOpen, setIsSaleDetailDialogOpen] = useState(false);
  const [accessDuration, setAccessDuration] = useState("7");
  const [savingAccess, setSavingAccess] = useState(false);
  const [accessError, setAccessError] = useState("");
  const [manualAccess, setManualAccess] = useState({
    active: item.manualFreeAccess?.active === true,
    expiresAt: item.manualFreeAccess?.expiresAt || null,
  });
  const onToggleSaleDetailDialog = (): void => {
    setIsSaleDetailDialogOpen(!isSaleDetailDialogOpen);
  };

  const { onChageFormToEditMode, handleSubmit, isSubmitting } = props;
  const isEditMode = mode === "edit" || mode === "detail";
  const manualExpiryMs = manualAccess.expiresAt
    ? Date.parse(manualAccess.expiresAt)
    : Number.POSITIVE_INFINITY;
  const manualAccessActive =
    manualAccess.active &&
    (!manualAccess.expiresAt || manualExpiryMs > Date.now());

  const saveFreeAccess = async (enabled: boolean) => {
    setSavingAccess(true);
    setAccessError("");
    try {
      const result = await props.onSetFreeAccess(
        item.id,
        accessDuration === "indefinite" ? null : Number(accessDuration),
        enabled
      );
      setManualAccess(result);
    } catch (error) {
      setAccessError(
        error instanceof Error ? error.message : "Could not update free access."
      );
    } finally {
      setSavingAccess(false);
    }
  };

  return (
    <Wrapper>
      <Form>
        {renderPersonalInfoSection(props)}

        {isEditMode && renderContactSection(item)}
        {isEditMode && (
          <Section>
            {renderSectionTitle("Complimentary access")}
            <p style={{ margin: "0 0 12px", color: "#5f6368" }}>
              {manualAccessActive
                ? manualAccess.expiresAt
                  ? `Free access is active until ${new Date(
                      manualAccess.expiresAt
                    ).toLocaleString()}.`
                  : "Free access is active indefinitely."
                : item.isSubscribed
                ? "This customer has access from a purchase or another grant."
                : "No complimentary access is active."}
            </p>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                flexWrap: "wrap",
                marginBottom: 8,
              }}
            >
              <select
                value={accessDuration}
                onChange={(event) => setAccessDuration(event.target.value)}
                disabled={savingAccess}
                aria-label="Free access duration"
                style={{ minHeight: 38, padding: "0 12px" }}
              >
                <option value="3">3 days</option>
                <option value="7">1 week</option>
                <option value="30">30 days</option>
                <option value="indefinite">Indefinite</option>
              </select>
              <button
                type="button"
                disabled={savingAccess}
                onClick={() => saveFreeAccess(true)}
                style={{ minHeight: 38, padding: "0 16px" }}
              >
                {savingAccess ? "Saving..." : "Grant free access"}
              </button>
              {manualAccessActive && (
                <button
                  type="button"
                  disabled={savingAccess}
                  onClick={() => saveFreeAccess(false)}
                  style={{ minHeight: 38, padding: "0 16px" }}
                >
                  Remove free access
                </button>
              )}
            </div>
            {accessError && (
              <p style={{ color: "#b42318", margin: 0 }}>{accessError}</p>
            )}
          </Section>
        )}
        {renderObservationSection(props)}

        {isEditMode && (
          <Table
            dataset={questions}
            currentPage={0}
            tabConfig={questionTabConfig}
            updatePageIndex={() => {}}
          />
        )}
        <ActionFormButton
          onChageFormToEditMode={onChageFormToEditMode}
          onClick={() => {
            handleSubmit();
          }}
          canBeRemoved={false}
          disabled={isSubmitting}
          mode={mode}
        />
      </Form>
    </Wrapper>
  );
};

const CustomForm = withFormik({
  mapPropsToValues: ({
    item,
    customers,
  }: {
    item: Customer;
    onCreateItem;
    onEditItem;
    mode;
    customers: Customer[];
  }): Customer => {
    const communityId = item.communityId || (customers && customers.length > 0 ? customers[0].communityId : "");

    return {
      id: item.id || "",
      email: item.email || "",
      fullName: item.fullName || "",
      phoneNumber: item.phoneNumber || "",
      createdAt: item.createdAt || 0,
      isActive: item?.isActive !== undefined ? item.isActive : true,
      communityId: communityId,
      experience: item.experience || 0,
    };
  },

  validationSchema: ({ cpfsRegistered, rgsRegistered, item, mode }) =>
    Yup.lazy(() => {
      const baseSchema = {
        fullName: Yup.string().required("The name is required."),
        email: Yup.string().email("Invalid email format"),
      };

      if (mode === "create") {
        return Yup.object().shape({
          ...baseSchema,
          email: Yup.string()
            .email("Invalid email format")
            .required("Email is required"),
          password: Yup.string()
            .min(6, "Password must be at least 6 characters")
            .required("Password is required"),
          confirmPassword: Yup.string()
            .oneOf([Yup.ref("password"), null], "Passwords must match")
            .required("Confirm password is required"),
        });
      }

      return Yup.object().shape(baseSchema);
    }),

  handleSubmit(values, { setSubmitting, props }) {
    const { onCreateItem, onEditItem, mode } = props;

    const properCallback = mode === "edit" ? onEditItem : onCreateItem;

    properCallback({
      ...values,
    });

    setSubmitting(false);
  },
  //@ts-ignore
})(CustomerForm);
export default CustomForm;
